// extracted by mini-css-extract-plugin
module.exports = {"footer":"style-module--footer--3_4dG","footer__container":"style-module--footer__container--1_TGT","footer__logo":"style-module--footer__logo--2aEUk"};